import { createSlice } from '@reduxjs/toolkit'
import { PURGE } from 'redux-persist'

import type { FilterParam } from 'features/bedboardManagement/types'
import type { RootState } from 'store/store'

export interface BedboardState {
  intialBedStatistics: number
  selectedOrgForStat: { id: string; name: string }[]
  selectedCommunityid: number
  selectedCommunityName: string
  sortVal: string
  // Community-detail filter panel (gender/bed type). Persisted so applied filters
  // survive navigation/reload (Bug 16295). Scoped to a community so filters reset
  // when the user opens a different community's details.
  detailFilterParams: FilterParam[]
  detailFilterCommunityId: number
}

const initialState: BedboardState = {
  intialBedStatistics: 0,
  selectedOrgForStat: [],
  selectedCommunityid: 0,
  selectedCommunityName: '',
  sortVal: '',
  detailFilterParams: [],
  detailFilterCommunityId: 0,
}
// slice
export const bedBoardSlice = createSlice({
  name: 'bedBoardManagement',
  initialState,
  reducers: {
    setBedBoardList: (state, action) => {
      state.intialBedStatistics = action.payload
    },
    setSelectedOrgForStat(state, action) {
      state.selectedOrgForStat = action.payload
    },
    setSelectedCommunityId(state, action) {
      state.selectedCommunityid = action.payload
    },
    setSelectedCommunityNameAction(state, action) {
      state.selectedCommunityName = action.payload
    },
    setSortVal(state, action) {
      state.sortVal = action.payload
    },
    setDetailFilterParams(state, action) {
      state.detailFilterParams = action.payload.filterParams
      state.detailFilterCommunityId = action.payload.communityId
    },
  },
  extraReducers: builder => {
    builder.addCase(PURGE, () => initialState)
  },
})

// Actions
export const bedBoardActions = {
  setTaskDetail: bedBoardSlice.actions.setBedBoardList,
  setSelectedCommunityById: bedBoardSlice.actions.setSelectedCommunityId,
  setSelectedCommunityName: bedBoardSlice.actions.setSelectedCommunityNameAction,
  setSortValForStatistics: bedBoardSlice.actions.setSortVal,
  setDetailFilterParams: bedBoardSlice.actions.setDetailFilterParams,
}

// Selectors
export const selectTaskDetails = (state: RootState) => state.tasks.taskDetail
export const getSelectedOrgForStat = (state: RootState) => state.bedBoard.selectedOrgForStat
export const getSelectedCommunityByid = (state: RootState) => state.bedBoard.selectedCommunityid
export const getSelectedCommunityName = (state: RootState) => state.bedBoard.selectedCommunityName
export const getSortValForStatistics = (state: RootState) => state.bedBoard.sortVal
export const getDetailFilterParams = (state: RootState) => state.bedBoard.detailFilterParams
export const getDetailFilterCommunityId = (state: RootState) =>
  state.bedBoard.detailFilterCommunityId

export const { setSelectedOrgForStat } = bedBoardSlice.actions
// Reducer
export default bedBoardSlice.reducer
